import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, with later Tailwind utilities winning over earlier ones.
 *
 * Without the merge step, a caller passing `p-8` to a component that already
 * sets `p-4` gets both, and which one applies depends on stylesheet order —
 * which is to say, on luck.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
